<table red-table 
        [attr.fontSize]="fontSize" 
        [attr.minSize]="minSize" 
        [attr.theme]="theme"
        [attr.marginBottom]="marginBottom ? marginBottom : null">
    <ng-content></ng-content>
</table>